import React from 'react';

class ConfirmationNote extends React.Component {
    constructor (props) {
        super(props);
    }

    render() {
        var {shopName, orderId, orderDatetime, orderItem, orderEmail, orderPhone} = this.props;
        return(
            <React.Fragment>
                <h1 className="confirmation-note-header">Thank you!</h1>
                <div className="order-summary">
                    <div className="order-summary-detail"><b>Request #{orderId}</b></div>
                    <div className="order-summary-detail">Items ordered: {orderItem}</div>
                    <div className="order-summary-detail">Estimated pickup time: {orderDatetime} </div>
                </div>
                <div className="confirmation-details">
                    Your request has been submitted to {shopName}.<br/>
        They will contact you by phone to confirm the order. A copy of this request will be sent to {orderEmail}.
                </div>
                <button onClick={() => window.open("https://backyardbirdshop.com", "_self")} className="button-exit">Back to shop</button>

            </React.Fragment>
        );
    }

}

export default ConfirmationNote;
